import React, { useState } from 'react';
import { CheckHistoryEntry } from 'services/reportsApi';

interface Props {
  count: number;
  history: CheckHistoryEntry[];
}

const fmtDate = (iso: string | null): string => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toISOString().slice(0, 10);
};

export const ReissuedBadge: React.FC<Props> = ({ count, history }) => {
  const [open, setOpen] = useState(false);

  return (
    <span className="relative inline-flex">
      <button
        type="button"
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        onClick={() => setOpen((o) => !o)}
        className="ml-2 inline-flex items-center rounded-full bg-amber-100 px-2 py-0.5 text-xs font-semibold text-amber-800 hover:bg-amber-200"
        aria-label={`Reissued ${count} times`}
      >
        Reissued ×{count}
      </button>
      {open && history.length > 0 && (
        <div
          role="tooltip"
          className="absolute left-0 top-full z-50 mt-1 w-72 rounded-lg bg-black-900 p-3 text-xs text-white shadow-dropDown"
        >
          <div className="mb-1 font-semibold">Check history</div>
          <ol className="space-y-1">
            {history.map((h, idx) => (
              <li key={`${h.check_number}-${idx}`} className="flex justify-between gap-2">
                <span className="font-mono">{h.check_number}</span>
                <span className="text-gray-300">
                  {h.check_status ?? '—'} · {fmtDate(h.check_mailed_on)}
                </span>
              </li>
            ))}
          </ol>
        </div>
      )}
    </span>
  );
};

export default ReissuedBadge;
